
import { Component, Vue } from "vue-property-decorator";
import { WechatService,  UserService, OrderService, EmployerActivityService } from "src/services";
import { Toast, Dialog } from "vant";
import { tools, Pay } from "src/utils";

Component.registerHooks([
"beforeRouteEnter",
"beforeRouteLeave",
"beforeRouteUpdate" // for vue-router 2.2+
]);

@Component
export default class SubmitOrderUnsubscribe extends Vue
{
    /**
     * 是否完善信息
     * @private
     * @returns boolean
     */
    private isPerfect: boolean = true;

    /**
     * 选择人员
     * @protected
     * @returns boolean
     */
    protected showUserPopup: boolean = false;

    /**
     * 固定项目展开id集合
     * @private
     * @returns Array<number>
     */
    private fixedCollapseActive: Array<number> = [];

    /**
     * 加项项目展开id集合
     * @private
     * @returns Array<number>
     */
    private collapseActiveNames: Array<number> = [];

    /**
     * 用户相关信息
     * @private
     * @returns any
     */
    private memberInfo: any =
    {
        cardNo: null,
        cardType: null,
        cardTypeStr: null,
        employerMemberId: null,
        memberId: null,
        memberName: null,
        phone: null
    };

    /**
     * 套餐信息
     * @private
     * @returns any
     */
    private packageInfo: any =
    {
        baseItemTypes: [],
        basePrice: null,
        couponUsingAmount: null,
        needPayAmount: null,
        optionalItemTypes: [],
        optionalPrice: null,
        packageId: null,
        packageName: null,
        walletUsingAmount: null
    };

    /**
     * 选择优惠券
     * @protected
     * @returns boolean
     */
    protected showCouponPopup: boolean = false;

    /**
     * 优惠券信息
     * @private
     * @returns any
     */
    private couponInfo: any =
    {
        finalReduceAmount: null,
        finalAmount: null,
        couponId: null,
    };

    /**
     * 可用优惠券列表
     * @private
     * @returns any
     */
     private couponList: any = [];

    /**
     * 是否在加载中
     * @private
     * @returns boolean
     */
    private loading: boolean = false;

    /**
     * 选择日期
     * @private
     * @returns any
     */
    private selectOrderDate: string = null;

    /**
     * 取消授权报告弹框
     * @private
     * @returns boolean
     */
    private showOverlay: boolean = false;

    /**
     * 是否显示用户授权协议
     * @private
     * @returns boolean
     */
    public showAuthorization: boolean = false;
    
    /**
     * 选中加项id
     * @private
     * @returns any
     */
    private get selectOptionalItem(): any
    {
        let selectOptionalItemStorage = localStorage.getItem("selectOptionalItem");

        if(selectOptionalItemStorage)
        {
            return JSON.parse(selectOptionalItemStorage) || [];
        }

        return [];
    }
    
    /**
     * 获取固定套餐项目个数
     * @private
     * 
     * @returns number
     */
    private get fixedNum(): number
    {
        let sum = 0;

        this.packageInfo && this.packageInfo.baseItemTypes.forEach((item)=>
        {
            sum += item.items && item.items.length || 0
            
        })

        return sum;
    }

    /**
     * 套餐id
     * @private
     * @returns string
     */
    private get packageId(): string
    {
        return this.$route.query && (this.$route.query.packageId as string) || "";
    }

    /**
     * 产品id
     * @private
     * @returns string
     */
     private get productId(): string
    {
        return this.$route.query && (this.$route.query.productId as string) || "";
    }

    /**
     * 机构id
     * @private
     * @returns string
     */
     private get hospitalId(): string
    {
        return this.$route.query && (this.$route.query.hospitalId as string) || "";
    }

    /**
     * 获取当前登入信息
     * @private
     * @returns void
     */
    private get selectUserId(): any
    {
        let selectUserStorage = localStorage.getItem("selectUser");
        
        if(selectUserStorage)
        {
            return JSON.parse(selectUserStorage).employerMemberId || this.userInfo.userId;
        }

        return this.userInfo.userId;
    }

    /**
     * 获取当前登入信息
     * @private
     * @returns void
     */
    private get userInfo(): any
    {
        return this.$store.getters.userInfo || {};
    }

    /**
     * 页面是否回退-h5环境
     * @private
     * @returns boolean
     */
    private get goback(): boolean
    {
        if(this.$route.query && this.$route.query.goback)
        {
            return true;
        }

        return false;
    }

    /**
     * 组件创建钩子
     * @private
     * @returns void
     */
    private created(): void
    {
        if(!localStorage.getItem("userInfo"))
        {
            this.$router.replace({name:"login", query:{redirect: location.href}});
            return;
        }
        let data =
        {
            hospitalId: null,
            packageId: null,
            optionalItemIds: [],
            healthProductIds: [],
            employerMemberId: null
        }

        data.optionalItemIds = this.selectOptionalItem.optionalItemIds || [];
        data.healthProductIds = this.selectOptionalItem.healthProductIds || [];
        if(this.hospitalId)
        {
            data.hospitalId = this.hospitalId;
        }
        data.packageId = this.packageId;
        data.employerMemberId = this.selectUserId;
        this.getPreOrderInfo(data);
    }

    /**
     * 获取套餐详情
     * @private
     * @returns void
     */
    private async getPreOrderInfo(data: any): Promise<void>
    {
        try
        {
            let {content: result} =  await OrderService.instance.getPreOrderInfo(data);

            if(result.data)
            {
                this.packageInfo = result.data.packageInfo;
                // 获取优惠券列表
                this.productId && this.getCouponSuitable();
            }

        }
        catch(err)
        {
            Toast(err);
        }
    }

    /**
     * 获取优惠券列表
     * @private
     * @returns void
     */
     private async getCouponSuitable(): Promise<void>
    {
        try
        {
            let params = {
                id: this.productId,
                amount: this.packageInfo.needPayAmount
            };
            let {content: result} =  await EmployerActivityService.instance.couponSuitable(params);

            if(result.data)
            {
                this.couponList = result.data;
                this.couponInfo = result.data[0] || {};
            }

        }
        catch(err)
        {
            Toast(err);
        }
    }

    /**
     * 提交订单
     * @private
     * @returns void
     */
    private async onSubmit(): Promise<void>
    {
        try
        {
            let data =
            {
                packageId: this.packageId,
                hospitalId: this.hospitalId,
                optionalItemIds: this.selectOptionalItem.optionalItemIds,
                healthProductIds: this.selectOptionalItem.healthProductIds,
                agreeLicense: true,
            };
            let {content: result} =  await OrderService.instance.pendingCheckNotPayOrder(data);

            if(result.data)
            {
                Dialog.confirm({
                    message: '您已存在相同的体检订单待支付，是否再次提交新订单？',
                    confirmButtonText: "查看待支付订单",
                    cancelButtonText: "继续提交",
                    closeOnClickOverlay: true,
                })
                .then(() => {
                    this.onGoOrderList();
                })
                .catch(() => {
                    this.onConfirm();
                });
            }
            else {
                this.onConfirm();
            }
        }
        catch(err)
        {
            Toast(err);
        }
    }

    /**
     * 继续提交
     * @private
     * @returns void
     */
    private onConfirm(): void
    {
        this.onConfirmSubmitOrder();
    }

    /**
     * 跳转待支付订单
     * @private
     * @returns void
     */
    private onGoOrderList(): void
    {
        let waitPay: any = 1;
        this.$router.push({ name: "order-list", query: { type: waitPay } });
    }

    /**
     * 提交订单
     * @private
     * @returns string
     */
    private async onConfirmSubmitOrder(): Promise<any>
    {
        try
        {
            if(this.loading)
            {
                return false;
            }
            this.loading = true;

            let data =
            {
                packageId: this.packageId,
                hospitalId: this.hospitalId,
                optionalItemIds: this.selectOptionalItem.optionalItemIds,
                healthProductIds: this.selectOptionalItem.healthProductIds,
                agreeLicense: true,
                couponId: this.couponInfo.couponId || null,
            };

            let {content: result} = await OrderService.instance.pendingAdd(data);
            if(result.data)
            {
                localStorage.removeItem("selectOptionalItem");
                if (result.data.isNeedPay) {
                    this.$router.push({name: "pay", query:{ orderNo: result.data.orderNo }});
                }
                else {
                    this.$router.push({name: "order-detail-unsubscribe", params:{id: result.data.orderId}});
                }
            }

        }
        catch(err)
        {
            Toast(err);
        }
        finally
        {
            this.loading = false;
        }
    }

    /**
     * 组件进来之前
     * @private
     * @returns void
     */
    private beforeRouteEnter(to, from, next): void
    {
        let appid = localStorage.getItem("appid");
        if (!tools.isAndroid() && `/${appid}${to.path}` !== location.pathname)
        {
            location.assign(`/${appid}${to.fullPath}`);
        }
        else
        {
            next();
        }
    }
    
    /**
     * 获取企业参数配置
     * @private
     * @returns any
     */
    private get generalSettings(): any
    {
        let generalSettingsValue = localStorage.getItem("generalSettings");
        if(generalSettingsValue)
        {
            return JSON.parse(generalSettingsValue);
        }
        return [];
    }

    /**
     * 是否显示配置
     * @protected
     * @returns boolean
     */
    protected showStting(code: string): boolean
    {
        // A1001 -- 体检套餐列表页、详情页、提交订单页及订单详情页均不显示体检套餐价格及企业报销金额。
        // A1002 -- 体检套餐列表页、详情页均不显示体检套餐划线价格。
        let data = this.generalSettings.filter(res => res.code == code);
        if (data.length > 0)
        {
            return data[0].isOpen;
        }
        else
        {
            return true;
        }
    }
    
    /**
     * 确认切换优惠券
     * @private
     * @returns void
     */
    protected onConfirmCoupon(data: any): void
    {
        if (data) {
            this.couponInfo = data;
        }
        else {
            this.couponInfo = {
                finalReduceAmount: null,
                finalAmount: null,
                couponId: null,
            };
        }
        this.showCouponPopup = false;
    }

}
